import React, { Fragment } from 'react'

import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import DoctorHome from './DoctorHome';


export default function DoctorList() {
    return (
        <Fragment>            
            <Breadcrumbs mainTitle="List of Doctors" parent="Home" title="List of Doctors" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                    <DoctorHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
